
export const SHIPPING_RATES_REQUEST = "SHIPPING_RATES_REQUEST";
export const SHIPPING_RATES_SUCCESS = "SHIPPING_RATES_SUCCESS";
export const SHIPPING_RATES_FAIL = "SHIPPING_RATES_FAIL";
export const SELECT_SHIPPING_RATE = "SELECT_SHIPPING_RATE";

export const CREATE_SHIPMENT_REQUEST = "CREATE_SHIPMENT_REQUEST";
export const CREATE_SHIPMENT_SUCCESS = "CREATE_SHIPMENT_SUCCESS";
export const CREATE_SHIPMENT_FAIL = "CREATE_SHIPMENT_FAIL";
